import PickupOrderingDetailsSFC from "./PickupOrderingDetails.vue";
export const PickupOrderingDetails = PickupOrderingDetailsSFC;
